export default __webpack_public_path__ + "static/media/tent-servicing.b427838c.jpg";